import React                from "react";
import Store                from "Dashboard/Core/Store";
import Action               from "Dashboard/Core/Action";
import Utils                from "Dashboard/Utils/Utils";
import useList              from "Dashboard/Hooks/List";

// Components
import HolidayEdit          from "./HolidayEdit";

// Dashboard
import Main                 from "Dashboard/Components/Core/Main";
import Content              from "Dashboard/Components/Core/Content";
import Header               from "Dashboard/Components/Header/Header";
import ActionList           from "Dashboard/Components/Header/ActionList";
import Table                from "Dashboard/Components/Table/Table";
import TableHead            from "Dashboard/Components/Table/TableHead";
import TableBody            from "Dashboard/Components/Table/TableBody";
import TableRow             from "Dashboard/Components/Table/TableRow";
import TableHeader          from "Dashboard/Components/Table/TableHeader";
import TableCell            from "Dashboard/Components/Table/TableCell";
import TablePaging          from "Dashboard/Components/Table/TablePaging";
import TableActionList      from "Dashboard/Components/Table/TableActionList";
import TableAction          from "Dashboard/Components/Table/TableAction";
import DeleteDialog         from "Dashboard/Components/Dialogs/DeleteDialog";



/**
 * The Holiday List
 * @returns {React.ReactElement}
 */
function HolidayList() {
    const { fetch, load } = useList("scheduleHoliday");

    const data = Store.useState("scheduleHoliday");
    const { loading, canEdit, list, total, sort } = data;

    const { deleteElem } = Store.useAction("scheduleHoliday");


    // The Current State
    const [ action, elemID, startAction, endAction ] = Action.useActionID();


    // Handles the Edit Submit
    const handleEdit = () => {
        endAction();
        fetch();
    };

    // Handles the Delete Submit
    const handleDelete = async () => {
        endAction();
        const result = await deleteElem(elemID);
        if (result.success) {
            fetch();
        }
    };


    // Do the Render
    const elemName = Utils.getValue(list, "scheduleHolidayID", elemID, "fullName");

    return <Main>
        <Header message="HOLIDAYS_NAME" icon="holiday">
            <ActionList data={data} onAction={startAction} />
        </Header>
        <Content>
            <Table
                fetch={load}
                sort={sort}
                none="HOLIDAYS_NONE_AVAILABLE"
                isLoading={loading}
            >
                <TableHead>
                    <TableHeader field="name"  message="GENERAL_NAME"  isTitle />
                    <TableHeader field="day"   message="GENERAL_DAY"   align="center" maxWidth="80" />
                    <TableHeader field="month" message="GENERAL_MONTH" align="center" maxWidth="100" />
                    <TableHeader field="year"  message="GENERAL_YEAR"  align="center" maxWidth="80" />
                </TableHead>
                <TableBody>
                    {list.map((elem) => <TableRow key={elem.scheduleHolidayID} elemID={elem.scheduleHolidayID}>
                        <TableCell message={elem.name}      />
                        <TableCell message={elem.day}       />
                        <TableCell message={elem.monthName} />
                        <TableCell message={elem.yearText}  />
                    </TableRow>)}
                </TableBody>
                <TablePaging total={total} />
                <TableActionList onAction={startAction} canEdit={canEdit}>
                    <TableAction action="EDIT"   message="HOLIDAYS_EDIT_TITLE"   />
                    <TableAction action="DELETE" message="HOLIDAYS_DELETE_TITLE" />
                </TableActionList>
            </Table>
        </Content>

        <HolidayEdit
            open={action.isVCE}
            elemID={elemID}
            onSubmit={handleEdit}
            onClose={endAction}
        />
        <DeleteDialog
            open={action.isDelete}
            title="HOLIDAYS_DELETE_TITLE"
            message="HOLIDAYS_DELETE_TEXT"
            content={elemName}
            onSubmit={handleDelete}
            onClose={endAction}
        />
    </Main>;
}

export default HolidayList;
